<template>
  <svg
    width="216"
    height="216"
    viewBox="0 0 216 216"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_i_3360_24168)">
      <circle
        cx="107.824"
        cy="107.823"
        r="107.824"
        fill="url(#paint0_linear_3360_24168)"
      />
    </g>
    <circle
      cx="107.824"
      cy="107.823"
      r="105.128"
      stroke="url(#paint1_linear_3360_24168)"
      stroke-width="5.3912"
    />
    <g filter="url(#filter1_d_3360_24168)">
      <circle
        cx="107.819"
        cy="107.821"
        r="91.6505"
        stroke="url(#paint2_linear_3360_24168)"
        stroke-width="5.3912"
        stroke-linecap="round"
        stroke-dasharray="0.01 10.78"
        shape-rendering="crispEdges"
      />
    </g>
    <defs>
      <filter
        id="filter0_i_3360_24168"
        x="-0.000488281"
        y="-0.000976562"
        width="215.648"
        height="226.431"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="10.7824" />
        <feGaussianBlur stdDeviation="5.3912" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_3360_24168"
        />
      </filter>
      <filter
        id="filter1_d_3360_24168"
        x="8.0817"
        y="13.4756"
        width="199.475"
        height="199.474"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="5.3912" />
        <feGaussianBlur stdDeviation="2.6956" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_3360_24168"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_3360_24168"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_3360_24168"
        x1="215.648"
        y1="-0.000976562"
        x2="-0.000488281"
        y2="215.647"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FFCA17" />
        <stop offset="1" stop-color="#977400" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_3360_24168"
        x1="215.648"
        y1="-0.000976562"
        x2="-0.000488281"
        y2="215.647"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#EFEDDB" />
        <stop offset="1" stop-color="#AB8F54" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_3360_24168"
        x1="107.819"
        y1="16.1709"
        x2="107.819"
        y2="199.472"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#EFEDDB" />
        <stop offset="1" stop-color="#AB8F54" />
      </linearGradient>
    </defs>
  </svg>
</template>
